'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgAwards(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M7.902 2a4.402 4.402 0 014.402 4.402v.05l.001.062a4.528 4.528 0 01-1.286 3.184v3.172c0 .671-.447 1.13-1.064 1.13-.357 0-.631-.15-.912-.427l-1.1-1.125-1.107 1.132c-.274.27-.548.42-.905.42-.617 0-1.07-.458-1.07-1.13V9.778l-.149-.15A4.542 4.542 0 013.5 6.513v-.061-.05A4.403 4.403 0 017.902 2zm0 8.805c-.678 0-1.32-.153-1.893-.427v2.511l1.384-1.414a.76.76 0 01.55-.238c.199 0 .377.08.549.237L9.87 12.89v-2.548a4.384 4.384 0 01-1.969.464zm0-7.657c-1.782 0-3.224 1.466-3.253 3.309v-.055a3.254 3.254 0 006.507.055v.056c.005-1.8-1.356-3.26-3.069-3.36l-.185-.005z", fill: "currentColor" }))));
}

module.exports = SvgAwards;
//# sourceMappingURL=Awards.js.map
